(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fieldfire-spark-sales"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ff-sales__demo figure').forEach(figure => {
  const video = figure.querySelector('video');
  const play = figure.querySelector('button');
  const status = figure.querySelector('[data-sales-error]');
  if (!video || !play) return;
  play.addEventListener('click', async () => {
    try {
      await video.play();
      if (status instanceof HTMLElement) status.hidden = true;
    } catch {
      if (status instanceof HTMLElement) status.hidden = false;
    }
  });
  video.addEventListener('play', () => { play.hidden = true; });
  video.addEventListener('pause', () => { play.hidden = false; });
  video.addEventListener('play', () => {
    window.FieldFireAnalytics?.track('video_start', { video_title: 'Spark software walkthrough' });
  }, { once: true });
});
  } catch(e) { console.error(e); }
})();

})();
